export const checkUsable = (
    customFilterList: {
        id?: number;
        name?: string;
        conditionList?: {
            value?: number;
            field?: {
                id?: string;
                label?: string;
                fieldName?: string;
                name?: string;
                fieldType?: number;
            };
        }[];
    }[] = [],
    customDataSourceList: {
        id?: number;
        name?: string;
        fieldList?: {
            id?: string;
            label?: string;
            fieldName?: string;
            originalId?: string;
        }[];
    }[] = []
) => {
    const fields = customDataSourceList.reduce((pre, cur) => {
        return [...pre, ...(cur.fieldList || [])];
    }, [] as any);

    return customFilterList.map((item) => {
        const conditionList = item.conditionList;

        // 可用的逻辑：排序器中的所有字段，在当前可用字段中均存在
        const usable = conditionList?.every((condition) => {
            return fields?.some(
                (field) =>
                    field.id === condition.field?.id || field.originalId === condition.field?.id
            );
        });

        return {
            ...item,
            usable,
        };
    });
};
